import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

type SectionProps = {
  children: ReactNode
  id?: string
  className?: string
  /** Tighter top spacing for the first section on inner pages (below the header). */
  pageLead?: boolean
}

/** Vertical page rhythm: top + bottom padding (uses `--spacing-section` from md up). */
export function Section({ children, id, className, pageLead }: SectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'relative',
        pageLead
          ? 'pt-6 pb-12 md:pt-8 md:pb-[var(--spacing-section)]'
          : 'py-12 md:py-[var(--spacing-section)]',
        className
      )}
    >
      {children}
    </section>
  )
}
